export const ChevronBig = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M9.39844 1.01465L17.8837 9.49993L9.39844 17.9852"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  )
}
